(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["babylon-cross-sell-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseCrossSell = () => {
      const recommendation = document.getElementById('BabylonCrossSellInline');
      if (!recommendation || recommendation.dataset.initialised === 'true') return;
      recommendation.dataset.initialised = 'true';

      const placeAfterSparkLayer = () => {
        const sparkPdp = document.querySelector('spark-pdp');
        if (!sparkPdp) return false;
        if (sparkPdp.nextElementSibling !== recommendation) {
          sparkPdp.insertAdjacentElement('afterend', recommendation);
        }
        return true;
      };

      const placeRecommendation = () => {
        if (placeAfterSparkLayer()) return;
        const main = document.querySelector('#MainContent') || document.querySelector('main');
        if (main) main.append(recommendation);
      };

      placeRecommendation();
      const observer = new MutationObserver(() => {
        if (placeAfterSparkLayer()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseCrossSell, { once: true });
    } else {
      initialiseCrossSell();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
